export default __webpack_public_path__ + "static/media/a011-03.9942d89c.jpg";